// const API_BASE_URL = "https://char-counter-db.onrender.com/api/"; 
const API_BASE_URL = "http://145.79.13.34:5000/api/"; 
// 145.79.13.34:5000
// const API_BASE_URL = "http://localhost:5000/api/";
export default API_BASE_URL;
